import { useEffect, useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import dayjs from 'dayjs'

import { checkMfaBeforeLoad } from '~/utils/beforeLoad'
import { formatCurrency } from '~/utils/helpers'
import { IAccountStatus } from '~/types'
import { useRootStore } from '~/store/RootStore'

import {
  ContentWrapper,
  CurrentBalance,
  Grid,
  H6,
  Spacer,
} from '~/components/elements'
import Loading from '~/components/loading'
import { PaymentDetails } from '~/components/billing/PaymentDetails'
import { BillingHistory } from '~/components/billing/BillingHistory'
import { Invoices } from '~/components/billing/Invoices'

const BillingPage = () => {
  const { billing } = useRootStore()
  const [isLoading, setIsLoading] = useState(true)
  const [accountStatus, setAccountStatus] = useState<IAccountStatus | null>(
    null
  )

  useEffect(() => {
    getAccountStatus()
    getBillingHistory()
    getInvoices()
    // retrieve also the available payment methods
    // this should not cause delay the loading of the page
    billing.getAvailablePaymentMethods()
  }, [])

  const getAccountStatus = async () => {
    const status = await billing.getAccountStatusData()
    if (status && status.nextPaymentDate) {
      setIsLoading(false)
      setAccountStatus(status)
    }
  }

  // get billing history/transactions in db
  const getBillingHistory = async () => {
    const fromDate = dayjs().subtract(7, 'year').toDate()
    const toDate = dayjs().toDate()
    await billing.getBillingHistory(fromDate, toDate)
  }

  // get invoices
  const getInvoices = async () => {
    await billing.getInvoicesData()
  }

  return (
    <ContentWrapper>
      {isLoading && <Loading />}
      <Grid columns="1fr 1fr" columnsmobile="1fr" gap="24px">
        {accountStatus ? (
          <>
            <div>
              <CurrentBalance>
                {formatCurrency(accountStatus.accountBalance || 0)}
                {accountStatus.accountBalance &&
                accountStatus.accountBalance < 0
                  ? ' CR'
                  : ''}
                <div style={{ fontSize: '16px' }}>Current Owing Balance</div>
              </CurrentBalance>
            </div>
            <PaymentDetails
              accountStatus={accountStatus}
              onSuccess={getAccountStatus}
            />
          </>
        ) : null}
      </Grid>

      <H6>Invoices</H6>
      <Invoices />

      <Spacer height="24px" />

      <H6>Billing History</H6>
      <BillingHistory />
    </ContentWrapper>
  )
}

export const Route = createFileRoute('/_authenticated/billing/')({
  beforeLoad: checkMfaBeforeLoad,
  component: BillingPage,
})
